import { CircularProgress, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

import {
    SpinnerContainer,
    spinnerProgressSx,
    SpinnerText } from './styled';

interface Props {
    text?: string;
}

const PlanningSpinner: FunctionComponent<Props> = ({
    text = 'Analyzing your request...'
}) => (
    <SpinnerContainer>
        <CircularProgress size={48} sx={spinnerProgressSx} />
        <Typography sx={SpinnerText}>{text}</Typography>
    </SpinnerContainer>
);

export default PlanningSpinner;
